import React, { useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Navbar, Container, Nav } from "react-bootstrap";
import { GiHamburgerMenu } from "react-icons/gi";
import { isLoggedIn } from "../Auth/isAuthenticated";
import { user } from "./auth/authhelper";
import "./Nav.css";
import { API } from "../API"
import { useAppContext } from "../Context/AppContext";

import axios from "axios";

const NavBar = ({ category, categoryLogo, categoryId }) => {
  const { headerLogo, totalQuantity } = useAppContext();
  const [userData, setUserData] = useState();
  const history = useHistory();
  const location = useLocation(); // To get the current path

  useEffect(() => {
    const getData = async () => {
      const d = await user();
      setUserData(d);
    };
    getData();
  }, []);


  console.log(category)

  const openNav = () => {
    document.getElementById("mySidenav").style.width = "250px";
  };

  const closeNav = () => {
    document.getElementById("mySidenav").style.width = "0";
  };

  const isActive = (path) => location.pathname === path;

  // Check if current path matches hidden routes
  const isHiddenRoute = () => {
    const hiddenRoutePatterns = [/^\/category\/[a-z0-9]+$/, /^\/view\/[a-z0-9]+$/];
    return hiddenRoutePatterns.some((pattern) => pattern.test(location.pathname));
  };
  const hidden = isHiddenRoute() || categoryLogo || category;
  console.log("Category:", category);

  return (
    // <div style={{ width: "95%", top: "0", zIndex: "30", }}>
    <div className="w-[95%] fixed top-0 z-30 bg-white shadow-md">

      {/* position: "absolute", top: "0", zIndex: "10", */}
      <Container>
        <Navbar className="navbar-expand d-flex flex-wrap">
          {/* <Nav.Link as={Link} to="/">
            <div
              className={`text-decoration-none pe-3 ${isActive("/") ? "text-warning" : "text-dark"
                }`}
              style={{ textShadow: "1px 1px 1px black" }}
            >
              Home
            </div>
          </Nav.Link> */}
          <Nav.Link
            as={Link}
            to="/"
            onClick={(e) => {
              if (hidden) {
                e.preventDefault(); // Prevent navigation
              }
            }}
            className={`text-decoration-none pe-3 ${isActive("/") ? "text-warning" : "text-dark"}`}
            style={{
              textShadow: "1px 1px 1px black",
              pointerEvents: hidden ? "none" : "auto", // Ensures proper behavior
              cursor: hidden ? "not-allowed" : "pointer", // Use not-allowed for clarity
            }}

          >
            <div>
              {headerLogo ? (
                <img
                  src={headerLogo}
                  alt="Logo"
                  className="img-fluid"
                  style={{ height: "51px" }} // Adjust the height as needed
                />
              ) : (
                "Home"
              )}
            </div>
          </Nav.Link>

          {!hidden && <Nav className="me-auto d-flex flex-wrap">
            <Nav.Link as={Link} to="/videos">
              <div
                className={`text-decoration-none ${isActive("/videos") ? "text-warning" : "text-dark"
                  }`}
                style={{ textShadow: "1px 1px 1px black" }}
              >
                Videos
              </div>
            </Nav.Link>
            {/* <Nav.Link as={Link} to="/tvshows">
              <div
                className={`text-decoration-none ${isActive("/tvshows") ? "text-warning" : "text-dark"
                  }`}
                style={{ textShadow: "1px 1px 1px black" }}
              >
                TvShows
              </div>
            </Nav.Link> */}
            {/* <Nav.Link as={Link} to="/shop">
              <div
                className={`text-decoration-none ${isActive("/shop") ? "text-warning" : "text-dark"
                  }`}
                style={{ textShadow: "1px 1px 1px black" }}
              >
                Shop
              </div>
            </Nav.Link> */}

          </Nav>}
          <div id="mySidenav" className="sidenav" style={{ width: "0px" }}>
            <div className="closebtn text-white" type="button" onClick={closeNav}>
              &times;
            </div>
            <br />




            {/* {isLoggedIn() && (
              <Link
                to="#"
                className="text-decoration-none text-dark text-center"
                onClick={() => {
                  localStorage.clear();
                  history.push(`/`);
                  window.location.reload();
                }}
              >
                Log Out
              </Link>
            )} */}
            {/* {
              !isLoggedIn() && (
                <Link
                  to="#"
                  className="text-decoration-none text-dark text-center"
                  onClick={() => {
                    history.push(`/login`);
                    // window.location.reload(); // Optional: Consider removing reload
                  }}
                >
                  Login
                </Link>
              )
            } */}


            {!isLoggedIn() && (<Link
              to="/login"
              className={`text-decoration-none ${isActive("/profile") ? "text-warning" : "text-dark"
                } mt-1 text-center`}
              style={{ textShadow: "1px 1px 1px black" }}
            >
              Login
            </Link>)}
            {/* Add more links below */}

            {isLoggedIn() && (<Link
              to="/profile"
              className={`text-decoration-none ${isActive("/profile") ? "text-warning" : "text-dark"
                } mt-1 text-center`}
              style={{ textShadow: "1px 1px 1px black" }}
            >
              Profile
            </Link>)}
            {isLoggedIn() && (<Link
              to="/checkout"
              className={`text-decoration-none ${isActive("/checkout") ? "text-warning" : "text-dark"
                } mt-1 text-center`}
              style={{ textShadow: "1px 1px 1px black" }}
            >
              Checkout
              {totalQuantity > 0 && <span
                className="ms-2 bg-warning text-dark rounded px-2 py-1 fw-bold"
                style={{
                  fontSize: "0.9rem",
                }}
              >
                {totalQuantity}
              </span>}
            </Link>)}
            {isLoggedIn() && (<Link
              to="/cartaddress"
              className={`text-decoration-none ${isActive("/cartaddress") ? "text-warning" : "text-dark"
                } mt-1 text-center`}
              style={{ textShadow: "1px 1px 1px black" }}
            >
              Address for Cart
            </Link>)}

            <Link
              to="/contact"
              className={`text-decoration-none ${isActive("/contact") ? "text-warning" : "text-dark"
                } mt-1 text-center`}
              style={{ textShadow: "1px 1px 1px black" }}
            >
              Contact Us
            </Link>
            <Link
              to="/about"
              className={`text-decoration-none ${isActive("/about") ? "text-warning" : "text-dark"
                } mt-1 text-center`}
              style={{ textShadow: "1px 1px 1px black" }}
            >
              About Us
            </Link>
            <Link
              to="/termcondition"
              className={`text-decoration-none ${isActive("/termcondition") ? "text-warning" : "text-dark"
                } mt-1 text-center`}
              style={{ textShadow: "1px 1px 1px black" }}
            >
              Terms and Conditions
            </Link>

            <Link
              to="/privacypolicy"
              className={`text-decoration-none ${isActive("/privacypolicy") ? "text-warning" : "text-dark"
                } mt-1 text-center`}
              style={{ textShadow: "1px 1px 1px black" }}
            >
              Privacy Policy
            </Link>
            {/* <Link
              to="/changepassword"
              className={`text-decoration-none ${isActive("/changepassword") ? "text-warning" : "text-dark"
                } mt-1 text-center`}
              style={{ textShadow: "1px 1px 1px black" }}
            >
              Change Password
            </Link> */}
          </div>
          {categoryLogo ? (
            // Show category name without click functionality
            <span
              className="d-flex justify-content-end"
              style={{
                position: "absolute", // Required for positioning relative to the parent
                top: "2", // Align to the top
                right: "0", // Align to the right
              }}
            >
              <Link to={`/channel/${categoryId}`}>
                <img
                  src={categoryLogo}
                  alt="Category Logo"
                  style={{
                    maxWidth: "10rem", // Set a fixed width for the logo
                    maxHeight: "3rem", // Set a fixed height for the logo
                    borderRadius: "10%", // Make the edges rounded
                    cursor: "pointer", // Indicate the image is clickable
                    transition: "transform 0.2s ease", // Smooth zoom effect
                  }}
                  onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")} // Zoom in on hover
                  onMouseLeave={(e) => (e.target.style.transform = "scale(1)")} // Reset zoom on leave
                />
              </Link>
            </span>


          ) : (
            // !isHiddenRoute() && (
            //   <span
            //     onClick={openNav} // Function to open navigation menu
            //     className="text-dark cursor-pointer" // Styling classes
            //     id="gitHambuergerMenu" // Element ID
            //   >
            //     <GiHamburgerMenu /> {/* Icon representing the hamburger menu */}
            //   </span>
            // )
            null
          )}


        </Navbar>
      </Container>
    </div>
  );
};

export default NavBar;
